var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.advertiseUrl)?_c('div',[_c('img',{staticClass:"land-page-img",attrs:{"src":_vm.advertiseUrl,"alt":""},on:{"click":function($event){return _vm.imgClick()}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }